/** A short handle for a request, "REQ-1A2B", as the approval queue's mockup
 *  labels its rows (owner, 2026-10-09). The first four hex of its uuid. */
export const reqRef = (id: string) => `REQ-${id.replace(/-/g, '').slice(0, 4).toUpperCase()}`;
